
    <ml-right-sidenav>
      <div class="main-layout layout-row flex">
        <ml-sidenav
          fxShow.lg
          fxHide
          [active]="active"
          [sidenavOptions]="sidenavOptions"
          [user]="user"
        ></ml-sidenav>
        <div class="main-container layout-column flex">
          <ml-app-bar
            [user]="user"
            [connection]="connection"
            [title]="tabBarTitle"
            [sidenavOptions]="sidenavOptions"
            [unreadNotifications]="unreadNotifications"
            (logout)="onLogOut()"
            (openNotifications)="onOpenNotifications()"
          ></ml-app-bar>
          <section class="main-content">
            <div class="content-container">
              <div class="content">
                <div *ngIf="!connection" class="no-connection">
                  {{ 'no-connection' | translate }}
                </div>
                <router-outlet></router-outlet>
              </div>
            </div>
          </section>
          <div *ngIf="isCustomer" class="contact-information">
            <ml-administrator-contact-information></ml-administrator-contact-information>
          </div>
        </div>
      </div>
    </ml-right-sidenav>
  